module.exports = __webpack_public_path__ + "static/media/ams-success-img.6bb73115.png";